<template>
    <el-dialog :title="title" :visible.sync="visible" :width="width" :height="height" :modal="modal" :before-close="beforeClose" :close-on-click-modal="closeOnClickModal" v-bind="$attrs">
        <slot></slot>
        <span slot="footer" class="dialog-footer">
            <slot name="footer"></slot>
        </span>
    </el-dialog>
</template>
<script>
export default {
    name: 'Modal1',
    props: {
        title: {
            type: String,
            default: () => $t('integration.tips')
        },
        width: {
            type: String
        },
        height: {
            type: String
        },
        modal: {
            type: Boolean,
            default: true
        },
        visible: {
            type: Boolean,
            default: false
        },
        closeOnClickModal: {
            type: Boolean,
            default: true
        },
        center: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        // author：brian
        beforeClose() {
            // 关闭前的回调，会暂停 Dialog 的关闭
            this.cancel();
        },
        cancel() {
            // 关闭弹窗，$emit触发自定义事件close
            this.$emit('close');
        }
    }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog {
    border: 5px solid $blue1;
    border-radius: 10px;
}
::v-deep .el-dialog__header {
    background-color: $blue1;
    padding: 5px 0;
    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        padding-left: 20px;
    }
    .el-dialog__close:hover {
        color: $txtcolor8;
        background-color: $red;
    }
}
::v-deep .el-dialog__headerbtn {
    top: 5px;
    i {
        color: $txtcolor1;
        font-size: 18px;
    }
}
::v-deep .el-form-item__label {
    width: auto;
    white-space: nowrap;
    text-align: right;
}

::v-deep .el-form-item__content {
    margin-left: 0;
}
::v-deep .el-dialog__footer {
    text-align: center;
    padding: 10px 0;
    border-top: 1px solid #f2f2f2;
}
</style>
